export const RobotoFont = '"Roboto", sans-serif';
export const LoraFont = RobotoFont;
export const MontserratFont = RobotoFont;
export const NunitoFont = RobotoFont;
export const FigtreeFont = '"Figtree", sans-serif';
